import Cashier from '@components/Cashier'
import CashierOrder from '@components/CashierOrder'
import Bond from '@components/Store/Bond'
import Desc from '@components/Store/Bond/Desc'
import Pay from '@components/Store/Bond/Pay'
import ResultPage from '@components/Cashier/ResultPage'
export default [
  {
    path: 'cashier',
    component: Cashier,
    stat: '收银台'
  },
  {
    path: 'cashierOrder',
    component: CashierOrder
  },
  {
    path: 'resultPage',
    component: ResultPage
  },
  {
    path: 'bond',
    component: Bond,
    indexRoute: {
      component: Desc
    },
    stat: '放心购·保证金/首页',
    childRoutes: [
      {
        path: 'pay',
        component: Pay
      }
      // {
      //     path: 'example',
      //     component:Example
      // },
      // {
      //     path: 'view/:id',
      //     component:View
      // },
      // {
      //     path: 'pay',
      //     component:Pay
      // },
      // {
      //     path: 'record',
      //     component:Record
      // },
      // {
      //     path: 'rule',
      //     component:Rule
      // },
      // {
      //     path: 'explain',
      //     component:Explain
      // },
      // {
      //     path: 'enroll/:id',
      //     component:Enroll
      // },
      // {
      //     path: 'buy',
      //     component:Buy
      // }
    ]
  }
]
